function getItemsTotalHeight({ itemsHeights }) {
  return itemsHeights.reduce((totalHeight, height) => totalHeight + height, 0);
}
export {
  getItemsTotalHeight
};
//# sourceMappingURL=getItemsTotalHeight.js.map
